import { createContext, useContext } from 'react';

export interface BottomSheetConfig {
  isAbsolute?: boolean;
}

export interface TabbarContextType {
  setShowNavigation: (value: boolean) => void;
  setShowBottomSheet: (value: boolean) => void;
  setBottomSheet: (value: React.ReactNode, config?: BottomSheetConfig) => void;
  /** The sheet on screen now, read without re-rendering when it changes. */
  getBottomSheet: () => React.ReactNode;
}

export const TabbarContext = createContext<TabbarContextType | undefined>(
  undefined,
);

export const useTabbar = () => {
  const context = useContext(TabbarContext);

  if (!context) {
    throw new Error('useTabbar must be used within a TabbarProvider');
  }

  return context;
};
